import IbanService from "@/api/services/iban";
import { toCamelCase } from "@estaly/ui";

export default {
  namespaced: true,
  actions: {
    async fetch() {
      const response = await IbanService.get();
      if (!response?.success) return;

      return toCamelCase(response.data);
    },
    async update(_, data = {}) {
      const payload = new FormData();
      if (data.iban) payload.append("iban", data.iban);
      if (data.document) payload.append("document", data.document);

      const response = await IbanService.update(payload);
      return response?.success;
    },
    async confirm({ dispatch }, { claimFriendlyId }) {
      const response = await IbanService.confirm();
      if (!response?.success) return false;

      await dispatch("claims/fetch", claimFriendlyId, { root: true });
      return true;
    },
    async extractIban(_, { file } = {}) {
      if (!file) return null;

      const payload = new FormData();
      payload.append("document", file);

      const response = await IbanService.extract(payload);
      // Sentinels read by extractIbanMixin: null = extraction error,
      // "" = extraction ran but no IBAN found, value = found.
      if (!response?.success || response.data?.extraction_error) return null;

      return response.data?.iban ?? "";
    },
  },
};
